import React, { useEffect, useState } from 'react';
import cruz from '../assets/cruzBlanca.png';
import portada from '../assets/portada.jpeg';
import '../css/modalPerfil.css';
import { toastWarning } from '../funciones.js';
import DatosPerfil from './DatosPerfil';
import logoAprobar from '../assets/logoAprobar.png';
import logoDesaprobar from '../assets/logoDesaprobar.png';
import EditarPerfil from './EditarPerfil';

function ModalPerfil(props) {

    //const [perfil, setPerfil]=useState({rubros:[],productosOfrecidos:[],productosDemandados:[]});
    const [guardar, setGuardar] = useState(1)

    useEffect(() => {
        var perfil;
        if (!props.isEditar) {
            perfil = document.getElementById("contenedorPerfil");
            perfil.scroll(0, 0);
        }
        /*else
            perfil = document.getElementById("contenedorPerfil");*/ 
    }, [props.perfil])

    useEffect(() => {
        var imagenPerfil, perfil, portada, encabezadoScroll, encabezadoPerfil;
        if (props.isEditar) {
            imagenPerfil = "imagenMiPerfil";

            perfil = document.getElementById("contenedorMiPerfil");
            portada = document.getElementById("imagenMiPortada");
            encabezadoScroll = document.getElementById("encabezadoScrollMiPerfil");
            encabezadoPerfil = document.getElementById("encabezadoMiPerfil");
        } else {
            imagenPerfil = "imagenPerfilEmpresa";

            perfil = document.getElementById("contenedorPerfil");
            portada = document.getElementById("imagenPortada");
            encabezadoScroll = document.getElementById("encabezadoScrollPerfil");
            encabezadoPerfil = document.getElementById("encabezadoPerfil");

        }


        const heightPortadaInicial = 170;
        var heightPortadaNuevo;
        var heightPerfilInicial;
        var heightPortadaInicial2;
        /*if (window.height > 900)
            heightPortadaInicial2 = 170 ;
        else
            heightPortadaInicial2 = 170* 1.25 + 80;*/
        heightPortadaInicial2 = 170 - 80;

        perfil.addEventListener("scroll", () => {
            if (perfil.scrollHeight > perfil.offsetHeight + heightPortadaInicial2 || perfil.scrollTop === 0) {

                encabezadoPerfil.classList.remove('position-sticky');
                encabezadoPerfil.classList.remove('top-0');
                encabezadoPerfil.classList.remove('bg-white');

                if (heightPerfilInicial === undefined)
                    heightPerfilInicial = perfil.offsetHeight;

                if (perfil.scrollTop < 10) {
                    document.getElementById(imagenPerfil).classList.remove("d-none");
                } else {
                    document.getElementById(imagenPerfil).classList.add("d-none");
                }
                if (perfil.scrollTop >= 90) {
                    portada.classList.add("encabezadoFixed");
                    encabezadoScroll.classList.remove("opacity-0");
                    portada.style.height = heightPortadaInicial - 90 + "px";
                    perfil.style.maxHeight = heightPerfilInicial + 90 + "px";
                    perfil.style.height = heightPerfilInicial + 90 + "px";
                    if (props.isEditar) {
                        document.getElementById("btnEditarPerfilFixed").classList.remove("disabled");
                        document.getElementById("btnVerMiPerfilFixed").classList.remove("disabled");
                        document.getElementById("btnGuardarTodoFixed").classList.remove("disabled");
                        document.getElementById("btnConfiguracionFixed").classList.remove("disabled");
                        document.getElementById("btnHambugerFixed").classList.remove("disabled");
                        document.getElementById("btnCambiarContraseñaFixed").classList.remove("disabled");
                    }
                    else if (props.esAdmin) {
                        if (document.getElementById("aprobarFixed") !== null)
                            document.getElementById("aprobarFixed").classList.remove("disabled");
                        if (document.getElementById("desaprobarFixed") !== null)
                            document.getElementById("desaprobarFixed").classList.remove("disabled");
                        document.getElementById("btnConfigFixedAdmin").classList.remove("disabled");
                        //document.getElementById("btnHambugerFixedAdmin").classList.remove("disabled");

                    }
                } else {
                    portada.classList.remove("encabezadoFixed");
                    if (props.isEditar) {
                        document.getElementById("btnEditarPerfilFixed").classList.add("disabled");
                        document.getElementById("btnVerMiPerfilFixed").classList.add("disabled");
                        document.getElementById("btnGuardarTodoFixed").classList.add("disabled");
                        document.getElementById("btnConfiguracionFixed").classList.add("disabled");
                        document.getElementById("btnHambugerFixed").classList.add("disabled");
                        document.getElementById("btnCambiarContraseñaFixed").classList.add("disabled");
                    }
                    else if (props.esAdmin) {
                        if (document.getElementById("aprobarFixed") !== null)
                            document.getElementById("aprobarFixed").classList.add("disabled");
                        if (document.getElementById("desaprobarFixed") !== null)
                            document.getElementById("desaprobarFixed").classList.add("disabled");
                        document.getElementById("btnConfigFixedAdmin").classList.add("disabled");
                        //document.getElementById("btnHambugerFixedAdmin").classList.add("disabled");

                    }
                    encabezadoScroll.classList.add("opacity-0");
                    heightPortadaNuevo = heightPortadaInicial - perfil.scrollTop;
                    perfil.style.maxHeight = heightPerfilInicial + perfil.scrollTop + "px";
                    perfil.style.height = heightPerfilInicial + perfil.scrollTop + "px";
                    portada.style.height = heightPortadaNuevo + "px";
                }
            }
            else {
                if (window.screen.width > 575) {
                    encabezadoPerfil.classList.add('position-sticky');
                    encabezadoPerfil.classList.add('top-0');

                    encabezadoPerfil.classList.add('bg-white');
                }
            }
        })
        /*const params = {
            params:{
                id: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }
        console.log(params)
        axios.get(process.env.REACT_APP_URL + "empresa", params)
        .then(function (response) {
            //setPerfil(response.data);
            console.log(response.data)
        })
        .catch(function (error) {
            //return toast.error("Error al cargar los representantes");
        });
        if(props.isEditar){
            document.getElementById("ofertaDemanda").classList.remove("d-none");
            document.getElementById("datosRepresentante").classList.remove("d-none");
        }*/

    }, [])

    function guardarTodo() {
        setGuardar(guardar + 1);
    }

    function editarPerfil() {

        document.getElementById("editarPerfil").classList.remove("d-none");
        document.getElementById("datosMiPerfil0").classList.add("d-none");
        document.getElementById("btnEditarPerfil").classList.add("d-none");
        document.getElementById("btnVerMiPerfil").classList.remove("d-none");
        document.getElementById("btnGuardarTodo").classList.remove("d-none");
        //document.getElementById("btnCambiarContraseña").classList.remove("d-none");
        document.getElementById("btnEditarPerfilFixed").classList.add("d-none");
        document.getElementById("btnVerMiPerfilFixed").classList.remove("d-none");
        document.getElementById("btnGuardarTodoFixed").classList.remove("d-none");
        document.getElementById("modalMiPerfil").classList.add("editando");
        document.getElementById("btnConfiguracion").classList.add("d-none");
        document.getElementById("btnConfiguracionFixed").classList.add("d-none");
        document.getElementById("btnHambuger").classList.remove("d-none");
        document.getElementById("btnHambugerFixed").classList.remove("d-none");
        //document.getElementById("btnCambiarContraseñaFixed").classList.remove("d-none");
        document.getElementById("contenedorMiPerfil").scrollTo(0, 0);
        if (parseInt(localStorage.getItem(process.env.REACT_APP_WARNING_EDITAR_PERFIL)) !== 1) {
            toastWarning("Los cambios no serán permanentes hasta que los guarde")
            localStorage.setItem(process.env.REACT_APP_WARNING_EDITAR_PERFIL, 1)
        }
    }

    function verPerfil() {

        document.getElementById("editarPerfil").classList.add("d-none");
        document.getElementById("modalMiPerfil").classList.remove("editando");
        document.getElementById("datosMiPerfil0").classList.remove("d-none");
        document.getElementById("btnEditarPerfil").classList.remove("d-none");
        //document.getElementById("btnCambiarContraseña").classList.add("d-none");
        document.getElementById("btnVerMiPerfil").classList.add("d-none");
        document.getElementById("btnGuardarTodo").classList.add("d-none");
        document.getElementById("btnEditarPerfilFixed").classList.remove("d-none");
        document.getElementById("btnVerMiPerfilFixed").classList.add("d-none");
        //document.getElementById("btnCambiarContraseñaFixed").classList.add("d-none");
        document.getElementById("btnGuardarTodoFixed").classList.add("d-none");
        document.getElementById("contenedorMiPerfil").scrollTo(0, 0);
        document.getElementById("btnConfiguracion").classList.remove("d-none");
        document.getElementById("btnConfiguracionFixed").classList.remove("d-none");
        document.getElementById("btnHambuger").classList.add("d-none");
        document.getElementById("btnHambugerFixed").classList.add("d-none");
    }

    function desdePerfil() {
        localStorage.setItem(process.env.REACT_APP_DESDE_PERFIL, 1);
    }
    return (
        <>
            {/*<ModalPerfil props={perfil} isMiPerfil={true}/>   */}
            <div class="modal modal-perfil" id={props.isEditar ? "modalMiPerfil" : "modalPerfil"} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-perfil">
                    <div class={"modal-content rounded-4 modalPerfil " + (props.esAdmin ? "perfilAdmin" : "")}>
                        <div className='container position-relative'>

                            <div className='row mx-2'>
                                <div className='col'>
                                    <div className='imagenPerfil rounded-circle centrarContainer' id={props.isEditar ? "imagenMiPerfil" : "imagenPerfilEmpresa"}>
                                        {/*<img className='h-100 d-none' src={require("../assets/rubros/" + props.perfil.rubroUrl)} alt="" />*/}
                                        <div className='text-white text-center w-100 letraPerfil'>{props.perfil.nombre.charAt(0).toUpperCase()}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body p-0 " >
                            <img className='closeModalPerfil' data-bs-dismiss="modal" aria-label="Close" src={cruz} alt="" />

                            <div className='imagenPortada ' id={props.isEditar ? "imagenMiPortada" : "imagenPortada"}>
                                <div className='postion-relative'>

                                    <img className='w-100 imgPortada' src={props.perfil.rubroUrl ? require("../assets/rubros/" + props.perfil.rubroUrl) : ""} alt="" />
                                    <div className='encabezadoScroll opacity-0' id={props.isEditar ? "encabezadoScrollMiPerfil" : "encabezadoScrollPerfil"}>

                                        <div className='container'>
                                            <div className='row align-items-center altoEncabezado'>
                                                <div className={props.esReunion ? 'col-nombre-empresa-reunion col' : props.isEditar ? 'col col-nombre-empresa-mi-perfil' : props.esAdmin ? 'col ' + (props.perfil.estaAprobado === null ? 'col-nombre-empresa-perfil-admin' : 'col-nombre-empresa-perfil-admin-lg') : 'col col-nombre-empresa'}>
                                                    <h2 className='nombreEmpresaPerfil mb-0 text-white mx-2'>
                                                        {props.perfil.nombre}
                                                    </h2>

                                                </div>
                                                <div className='col-2 text-end align-self-center mx-2 w-fit-content'>
                                                    {props.esReunion ? (
                                                        <></>
                                                    ) : props.isEditar ? (
                                                        <>
                                                            <button id="btnEditarPerfilFixed" class="btn transition-none btn-outline-secondary bold-botones me-4 disabled btn-cuadrado ocultarMobile"
                                                                onClick={editarPerfil}>Editar Mi Perfil</button>
                                                            <button id="btnVerMiPerfilFixed" class="btn transition-none btn-outline-secondary bold-botones me-4 d-none disabled btn-cuadrado "
                                                                onClick={verPerfil}> Ver Perfil</button>
                                                            <button id="btnCambiarContraseñaFixed" class="btn transition-none btn-outline-secondary bold-botones me-4 disabled btn-cuadrado ocultarMobile"
                                                                data-bs-toggle="modal" data-bs-target="#modalCodigo" onClick={desdePerfil}> Cambiar Contraseña</button>
                                                            <button id="btnGuardarTodoFixed" class="btn colorPrincipal transition-none text-white bold-botones d-none disabled btn-cuadrado me-4"
                                                                type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                            <li id="dropdownConfiguracionFixed" class="dropdown ms-2 d-none mostrarMobile " >
                                                                <button id="btnConfiguracionFixed" class="btn colorPrincipal transition-none text-white bold-botones btn-cuadrado me-4 disabled"
                                                                    data-bs-toggle="dropdown" aria-expanded="false"> Configuración</button>

                                                                <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil">
                                                                    <li>
                                                                        <button class="btn colorPrincipal text-white me-3 bold-botones btn-cuadrado"
                                                                            onClick={editarPerfil}>Editar</button>

                                                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado "
                                                                            data-bs-toggle="modal" data-bs-target="#modalCodigo" onClick={desdePerfil}> Cambiar Contraseña</button>

                                                                        <div className="cruzMenuConfiguracion" alt="" />
                                                                    </li>

                                                                </ul>
                                                            </li>
                                                            <li id="dropdownHambugerFixed" class="dropdown ms-2 d-none" >
                                                                <button id="btnHambugerFixed" class="btn colorPrincipal transition-none text-white bold-botones btn-cuadrado me-4 d-none disabled"
                                                                    data-bs-toggle="dropdown" aria-expanded="false"><span class="navbar-toggler-icon"></span></button>

                                                                <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil">
                                                                    <li>
                                                                        <button class="btn colorPrincipal text-white bold-botones me-4 btn-cuadrado"
                                                                            onClick={verPerfil}> Ver Perfil</button>
                                                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                            type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                                        <div className="cruzMenuConfiguracion" alt="" />
                                                                    </li>
                                                                </ul>

                                                            </li>
                                                        </>
                                                    ) : props.esAdmin ? (
                                                        <>
                                                            {!props.perfil.estaAprobado || props.perfil.estaAprobado === null ?
                                                                <>
                                                                    <button id="aprobarFixed" class="btn transition-none btn-outline-secondary bold-botones btn-cuadrado 
                                                                        ocultarMobile w-btn-aprobar ms-4" onClick={() => props.evaluarUsuario(props.perfil.id, true, "aprobarFixed")}> Aprobar
                                                                    </button>
                                                                    <img id={"aprobarFixedMobile"} className='cursor-pointer img-blanco-mobile d-inline-block-mobile d-none' src={logoAprobar} alt="" onClick={() => props.evaluarUsuario(props.perfil.id, true, "aprobarFixedMobile")} />

                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                            {props.perfil.estaAprobado || props.perfil.estaAprobado === null ?
                                                                <>
                                                                    <button id="desaprobarFixed" class="btn transition-none btn-outline-secondary bold-botones btn-cuadrado
                                                                        ms-4 ocultarMobile w-btn-aprobar " onClick={desdePerfil} data-bs-toggle="modal"
                                                                        data-bs-target="#desaprobarUsuario"> Desaprobar
                                                                    </button>
                                                                    <img className={'ms-3 cursor-pointer img-blanco-mobile d-inline-block-mobile d-none' + (props.perfil.estaAprobado ? " logoDesaprobar" : "")} src={logoDesaprobar} alt="" onClick={desdePerfil} data-bs-toggle="modal"
                                                                        data-bs-target="#desaprobarUsuario" />
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                            <div id="dropdownConfigFixedAdmin" class="dropdown d-inline-block " >

                                                                <button id="btnConfigFixedAdmin" class="btn transition-none colorPrincipal mx-4 text-white bold-botones btn-cuadrado"
                                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className='ocultarMobile'>Configuración</div><div className='mostrarMobile d-none'><span class="navbar-toggler-icon"></span></div>
                                                                </button>
                                                                <ul class="dropdown-menu rounded-3">
                                                                    <li>
                                                                        <button class="btn btn-outline-primary bold-botones btn-cuadrado me-3  btn-verperfil-empresas "
                                                                            onClick={() => props.modificarMora(props.perfil.id, !props.perfil.estaEnMora)}>
                                                                            {props.perfil.estaEnMora ? 'Remover Mora' : 'Agregar Mora'}
                                                                        </button>

                                                                        <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal"
                                                                            data-bs-target="#modalCambiarUnion" onClick={desdePerfil}>Modificar Unión</button>

                                                                        <div className="cruzMenuConfiguracion" alt="" />

                                                                    </li>

                                                                </ul>
                                                            </div >

                                                            {/*<li id="dropdownHambugerFixedAdmin" class="dropdown  ms-2 d-none" >
                                                                        <button id="btnHambugerFixedAdmin" class="btn transition-none colorPrincipal text-white bold-botones btn-cuadrado me-4 disabled"
                                                                            data-bs-toggle="dropdown" aria-expanded="false"><span class="navbar-toggler-icon"></span></button>

                                                                        <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil ">
                                                                            <li>
                                                                                <button class="btn colorPrincipal text-white bold-botones me-4 btn-cuadrado"
                                                                                    onClick={verPerfil}> Ver Perfil</button>
                                                                                <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                                    type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                                                <div className="cruzMenuConfiguracion" alt="" />
                                                                            </li>
                                                                        </ul>

                                                                    </li>*/}
                                                        </>
                                                    ) : props.elementoModificado(props.perfil.id, props.idInscripcion) ? (
                                                        <button class="btn text-white bold-botones transition-none btnDisabled btn-cuadrado me-4" type="submit"
                                                        >Enviada</button>
                                                    ) : (
                                                        <button class="btn colorPrincipal text-white transition-none bold-botones btn-cuadrado me-4" type="submit"
                                                            onClick={() => props.reunirse(props.perfil.id)}>Reunirse</button>
                                                    )
                                                    }
                                                    <img className='closeModalPerfilFixed' data-bs-dismiss="modal" aria-label="Close" src={cruz} alt="" />

                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="containerPerfil mb-3" id={props.isEditar ? "contenedorMiPerfil" : "contenedorPerfil"}>
                                <div className='container pt-3 position-relative ' id={props.isEditar ? 'encabezadoMiPerfil' : 'encabezadoPerfil'}>

                                    <div className='row mx-2'>
                                        {/*props.isEditar?
                                        <div className='col-3'>
                                        
                                        </div>
                                        :
                                        <>
                                        </>*/
                                        }
                                        <div className='col mb-4 pb-1 text-end pe-0'>
                                            {props.esReunion ?
                                                <div className='py-3'></div>
                                                : props.isEditar ?
                                                    <>
                                                        <button id="btnEditarPerfil" class="btn btn-outline-primary bold-botones   btn-cuadrado ocultarMobile"
                                                            onClick={editarPerfil}>Editar Mi Perfil</button>
                                                        <button id="btnVerMiPerfil" class="btn btn-outline-primary bold-botones   d-none btn-cuadrado "
                                                            onClick={verPerfil}> Ver Perfil</button>
                                                        <button id="btnCambiarContraseña" class="btn btn-outline-primary bold-botones ms-4 btn-cuadrado ocultarMobile"
                                                            data-bs-toggle="modal" data-bs-target="#modalCodigo" onClick={desdePerfil}> Cambiar Contraseña</button>
                                                        <button id="btnGuardarTodo" class="btn colorPrincipal text-white ms-4 bold-botones d-none btn-cuadrado "
                                                            type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                        <li id="dropdownConfiguracion" class="dropdown ms-2 d-none mostrarMobile " >
                                                            <button id="btnConfiguracion" class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                data-bs-toggle="dropdown" aria-expanded="false"> Configuración</button>

                                                            <ul class="dropdown-menu rounded-3">
                                                                <li>
                                                                    <button class="btn colorPrincipal text-white me-3 bold-botones btn-cuadrado"
                                                                        onClick={editarPerfil}>Editar</button>

                                                                    <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                        data-bs-toggle="modal" data-bs-target="#modalCodigo" onClick={desdePerfil}> Cambiar Contraseña</button>

                                                                    <div className="cruzMenuConfiguracion" alt="" />

                                                                </li>

                                                            </ul>
                                                        </li>
                                                        <li id="dropdownHambuger" class="dropdown ms-2 d-none " >
                                                            <button id="btnHambuger" class="btn colorPrincipal text-white bold-botones btn-cuadrado "
                                                                data-bs-toggle="dropdown" aria-expanded="false"><span class="navbar-toggler-icon"></span></button>

                                                            <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil">
                                                                <li>
                                                                    <button class="btn colorPrincipal text-white  bold-botones me-4 btn-cuadrado"
                                                                        onClick={verPerfil}> Ver Perfil</button>
                                                                    <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                        type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                                    <div className="cruzMenuConfiguracion" alt="" />
                                                                </li>
                                                            </ul>

                                                        </li>
                                                    </>
                                                    : props.esAdmin ?
                                                        <>
                                                            {!props.perfil.estaAprobado || props.perfil.estaAprobado === null ?
                                                                <>
                                                                    <button id={"aprobarPerfil"} class="btn btn-cuadrado w-btn-aprobar btn-outline-primary   bold-botones ocultarMobile"
                                                                        onClick={() => props.evaluarUsuario(props.perfil.id, true, "aprobarPerfil")}> Aprobar
                                                                    </button>
                                                                    <img id={"aprobarMobile"} className='cursor-pointer img-blanco-mobile d-inline-block-mobile d-none' src={logoAprobar} alt="" onClick={() => props.evaluarUsuario(props.perfil.id, true, "aprobarMobile")} />
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                            {props.perfil.estaAprobado || props.perfil.estaAprobado === null ?
                                                                <>
                                                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado w-btn-aprobar ms-4 ocultarMobile"
                                                                        onClick={desdePerfil} data-bs-toggle="modal"
                                                                        data-bs-target="#desaprobarUsuario"> Desaprobar
                                                                    </button>
                                                                    <img className={'ms-3 cursor-pointer img-blanco-mobile d-inline-block-mobile d-none' + (props.perfil.estaAprobado ? " logoDesaprobar" : "")} src={logoDesaprobar} alt="" onClick={desdePerfil} data-bs-toggle="modal"
                                                                        data-bs-target="#desaprobarUsuario" />
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                            <div id="dropdownConfiguracionAdmin" class="dropdown d-inline-block " >

                                                                <button id="btnConfiguracionAdmin" class="btn colorPrincipal ms-4   text-white bold-botones btn-cuadrado"
                                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className='ocultarMobile'>Configuración</div><div className='mostrarMobile d-none'><span class="navbar-toggler-icon"></span></div>
                                                                </button>
                                                                <ul class="dropdown-menu rounded-3">
                                                                    <li>
                                                                        <button class="btn btn-outline-primary bold-botones btn-cuadrado me-3  btn-verperfil-empresas "
                                                                            onClick={() => props.modificarMora(props.perfil.id, !props.perfil.estaEnMora)}>
                                                                            {props.perfil.estaEnMora ? 'Remover Mora' : 'Agregar Mora'}
                                                                        </button>

                                                                        <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal"
                                                                            data-bs-target="#modalCambiarUnion" onClick={desdePerfil}>Modificar Unión</button>

                                                                        <div className="cruzMenuConfiguracion" alt="" />

                                                                    </li>

                                                                </ul>
                                                            </div >
                                                            {/*<li id="dropdownHambugerAdmin" class="dropdown ms-2 d-none" >
                                                                <button id="btnHambugerAdmin" class="btn colorPrincipal text-white bold-botones btn-cuadrado me-4 d-none disabled"
                                                                    data-bs-toggle="dropdown" aria-expanded="false"><span class="navbar-toggler-icon"></span></button>

                                                                <ul class="dropdown-menu rounded-3 dropdown-encabezado-mi-perfil">
                                                                    <li>
                                                                        <button class="btn colorPrincipal text-white bold-botones me-4 btn-cuadrado"
                                                                            onClick={verPerfil}> Ver Perfil</button>
                                                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"
                                                                            type="submit" onClick={guardarTodo}>Guardar Todo</button>
                                                                        <div className="cruzMenuConfiguracion" alt="" />
                                                                    </li>
                                                                </ul>

                                                            </li>*/}
                                                        </>
                                                        :
                                                        props.elementoModificado(props.perfil.id, props.idInscripcion) ?
                                                            <button class="btn text-white bold-botones btnDisabled btn-cuadrado" type="submit"
                                                            >Enviada</button>
                                                            :
                                                            <button class="btn colorPrincipal text-white bold-botones btn-cuadrado" type="submit"
                                                                onClick={() => props.reunirse(props.perfil.id)}>Reunirse</button>
                                            }
                                        </div>
                                    </div>
                                    <h2 className='nombreEmpresaPerfil mb-0 mx-2 pb-3'>
                                        {props.perfil.nombre}
                                    </h2>
                                </div>
                                <DatosPerfil perfil={props.perfil} isEditar={props.isEditar} esAdmin={props.esAdmin} />
                                {props.isEditar ?
                                    <EditarPerfil perfil={props.perfil} setPerfil={props.setPerfil} guardar={guardar} />
                                    :
                                    <></>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>

    );
}


export default ModalPerfil;